<template>
  <layout-basic>
    <page-hero
      title="Solve Your Biggest Training Challenges"
      lead="Whether you're onboarding new starters, managing compliance or developing future leaders, IMPROVE helps growing businesses train people more effectively."
    />

    <section class="solutions-grid-section">
      <v-container>
        <h2 class="font-sora solutions-heading">Choose a solution</h2>
        <div class="solutions-grid">
          <router-link
            v-for="item in solutions"
            :key="item.to"
            :to="item.to"
            class="solution-card"
          >
            <strong>{{ item.title }}</strong>
            <span>{{ item.blurb }}</span>
          </router-link>
        </div>
      </v-container>
    </section>

    <standard-cta
      title="Find the right solution for your business."
      lead="Watch the 5-minute demo or experience IMPROVE for yourself."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'Solutions',
  components: { LayoutBasic, PageHero, StandardCta },
  metaInfo() {
    return marketingPageMeta({
      title: 'Solutions | IMPROVE Training Challenges',
      description:
        'Solve onboarding, compliance, employee development, management development, health & safety, partner training and internal communications with IMPROVE.',
      path: '/solutions',
    });
  },
  data() {
    return {
      solutions: [
        { title: 'Employee Onboarding', blurb: 'Give every new starter the same great start.', to: '/solutions/onboarding' },
        { title: 'Compliance Training', blurb: 'Track mandatory training with confidence.', to: '/solutions/compliance' },
        { title: 'Employee Development', blurb: 'Grow skills across your whole workforce.', to: '/solutions/employee-development' },
        { title: 'Management Development', blurb: 'Build stronger managers and leaders.', to: '/solutions/management-development' },
        { title: 'Health & Safety', blurb: 'Keep H&S learning organised and visible.', to: '/solutions/health-and-safety' },
        { title: 'Partner Training', blurb: 'Train partners consistently at scale.', to: '/solutions/partner-training' },
        { title: 'Internal Communications', blurb: 'Share policies and updates in one place.', to: '/solutions/internal-communications' },
      ],
    };
  },
};
</script>

<style scoped>
.solutions-grid-section {
  padding: 24px 0 48px;
}

.solutions-heading {
  text-align: center;
  color: var(--brand-navy, #002458);
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 24px;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  max-width: 980px;
  margin: 0 auto;
}

.solution-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  padding: 22px 18px;
  text-decoration: none;
  color: var(--brand-navy, #002458);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.solution-card:hover {
  border-color: var(--brand-teal, #08a0a8);
  box-shadow: 0 8px 24px rgba(0, 36, 88, 0.08);
  color: var(--brand-navy, #002458);
}

.solution-card strong {
  font-size: 17px;
}

.solution-card span {
  color: var(--brand-grey, #6b7280);
  font-size: 14px;
  line-height: 1.45;
}

@media screen and (max-width: 900px) {
  .solutions-grid {
    grid-template-columns: 1fr;
  }
}
</style>
